import { render } from "./profilepicture.vue?vue&type=template&id=3ebbfc28&scoped=true"
import script from "./profilepicture.vue?vue&type=script&lang=js"
export * from "./profilepicture.vue?vue&type=script&lang=js"

import "./profilepicture.vue?vue&type=style&index=0&id=3ebbfc28&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebbfc28"]])

export default __exports__